import { createFileRoute } from '@tanstack/react-router';
import { ContentListPage } from '@/pages/content/ContentListPage';

export const Route = createFileRoute('/content/')({
  component: ContentListPage,
});
